import { Command } from '../../core/Command'

/**
 * 复合命令，将多个子命令打包为一个原子操作统一执行与撤销。
 */
export class CompositeCommand extends Command {
  constructor(private commands: Command[]) {
    super()
  }

  /** 按顺序执行所有子命令 */
  execute(): void {
    this.commands.forEach((command) => command.execute())
  }

  /** 按顺序撤销所有子命令 */
  undo(): void {
    this.commands.forEach((command) => command.undo())
  }
}
